import React from 'react';
import { Form, Button } from 'react-bootstrap';

export const BaseProductAttributes = (props) => {
  return (
    <>
      <table style={{ width: '100%' }}>
        <thead>
          <tr>
            <th style={{ width: '10%' }}>ID</th>
            <th style={{ width: '10%' }}>ASIN</th>
            <th style={{ width: '40%' }}>Name</th>
            <th style={{width: '5%'}}>Exclude</th>
            <th style={{ width: '10%' }}>Cost Price</th>
            <th style={{ width: '10%' }}>Weight</th>
            <th style={{ width: '10%' }}>Packaging</th>
            <th style={{ width: '5%' }}>Lock</th>
          </tr>
        </thead>
        <tbody>
          {props.selectedRows.map((productObj, index) => {
              return (
                <tr>
                  <td>{productObj.id}</td>
                  <td>{productObj.asin}</td>
                  <td>{productObj.name}</td>
                  <td>
                  <select
                    name='exclude'
                    id='exclude'
                    onChange={(e) => props.updateBaseProductAttribute(e, index)}
                    defaultValue={productObj.exclude}
                    disabled={productObj.lockBaseAttributes}
                  >
                    <option value={true}>True</option>
                    <option value={false}>False</option>
                  </select>
                </td>
                  <td>
                    <Form.Control
                      name='costPrice'
                      value={productObj.costPrice}
                      onChange={(e) => props.updateBaseProductAttribute(e, index)}
                      disabled={props.selectedRows.length > 1 || productObj.lockBaseAttributes}
                    ></Form.Control>
                  </td>
                  <td>
                    <Form.Control
                      name='weight'
                      value={productObj.weight}
                      onChange={(e) => props.updateBaseProductAttribute(e, index)}
                      disabled={props.selectedRows.length > 1 || productObj.lockBaseAttributes}
                    ></Form.Control>
                  </td>
                  <td>
                    <select
                      name='packaging'
                      id='packaging'
                      onChange={(e) => props.updateBaseProductAttribute(e, index)}
                      defaultValue={productObj.packaging}
                      disabled={props.selectedRows.length > 1 || productObj.lockBaseAttributes}
                    >
                      <option value='box'>box</option>
                      <option value='bag'>bag</option>
                    </select>
                  </td>
                  <td className='p-1'>
                    <Button
                      name='lockBaseAttributes'
                      size='sm'
                      value={productObj.lockBaseAttributes}
                      onClick={(e) => props.updateBaseProductAttribute(e, index)}
                      variant={productObj.lockBaseAttributes ? 'danger' : 'primary'}
                    >
                      {productObj.lockBaseAttributes ? 'Locked' : 'Unlocked'}
                    </Button>
                  </td>
                </tr>
              );
          })}
        </tbody>
      </table>
      <Button onClick={props.recalculateFromBasePrices}>Recalculate</Button>
    </>
  );
};
